export default __webpack_public_path__ + "static/media/bxl-git.6ed196f7.svg";